import { render, staticRenderFns } from "./AgentComponent.vue?vue&type=template&id=56b541ce&"
import script from "./AgentComponent.vue?vue&type=script&lang=js&"
export * from "./AgentComponent.vue?vue&type=script&lang=js&"
import style0 from "./AgentComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports